"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class TemplateCarrierAccounts {
}
exports.TemplateCarrierAccounts = TemplateCarrierAccounts;
//# sourceMappingURL=TemplateCarrierAccouts.js.map